/******** Authentication **********/
export const USER_AUTHENTICATION_URL = "/auth";
export const USER_LOGIN_URL = `${USER_AUTHENTICATION_URL}/login`;
export const USER_REGISTER_URL = `${USER_AUTHENTICATION_URL}/register`;
export const VALIDATE_EMAIL = `${USER_AUTHENTICATION_URL}/is-exists`;
export const GET_CURRENT_USER = `${USER_AUTHENTICATION_URL}/get-current-user`;
export const USER_LOGOUT = `${USER_AUTHENTICATION_URL}/logout`;

/******** USERS **********/
export const USERS_URL = "/users";
export const USER_FORGOT_PASS = `${USERS_URL}/pass/forgot-password`;
export const USER_CONFIRM_OTP = `${USERS_URL}/pass/confirm-otp`;
export const USER_RESET_PASS = `${USERS_URL}/pass/change-password`;
export const DELETE_USER = `${USERS_URL}/delete`;
export const SAVE_USER = `${USERS_URL}/add`;
export const USERS_PLANNER_URL = `${USERS_URL}/allPlanners`;
export const UPDATE_USER = `${USERS_URL}/update`;
export const CHECK_PASSWORD = `${USERS_URL}/check-password`;
export const GET_SPECIFIC_PLANNER = `${USERS_URL}/planner`
export const GET_USER_AGENCY_NAME = `${USERS_URL}/agency-name`

/******** APPLICANTS **********/
export const BASE_URL = "/admin";
export const APPLICANTS_URL = `${BASE_URL}/applicants`;
export const SAVE_APPLICANT = APPLICANTS_URL;
export const VALIDATE_APPLICANT_EMAIL = APPLICANTS_URL + "/checkEmailExists";
export const GET_APPLICANT = APPLICANTS_URL;

/******** ADMIN **********/
export const CATEGORIES_URL = "/category";
export const SAVE_CATEGORY = `${CATEGORIES_URL}/add`;
export const DELETE_CATEGORY = `${CATEGORIES_URL}/delete`;
export const WAREHOUSES_URL = "/warehouse";
export const SAVE_WAREHOUSE = `${WAREHOUSES_URL}/add`;
export const DELETE_WAREHOUSE = `${WAREHOUSES_URL}/delete`;
export const SUPPLIERS_URL = "/supplier";
export const SAVE_SUPPLIER = `${SUPPLIERS_URL}/add`;
export const DELETE_SUPPLIER = `${SUPPLIERS_URL}/delete`;
export const STORAGE_LOCATIONS_URL = "/storage-location";
export const SAVE_STORAGE_LOCATION = `${STORAGE_LOCATIONS_URL}/add`;
export const DELETE_STORAGE_LOCATION = `${STORAGE_LOCATIONS_URL}/delete`;
export const CLEARANCE_AGENTS_URL = "/agents";
export const SAVE_CLEARANCE_AGENT = `${CLEARANCE_AGENTS_URL}/add`;
export const DELETE_CLEARANCE_AGENT = `${CLEARANCE_AGENTS_URL}/delete`;
export const CLEARANCE_AGENT_DOCUMENTS_URL =`${CLEARANCE_AGENTS_URL}/add-document`;
export const CLEARANCE_AGENT_UPDATE_DOCUMENT_URL = (agentDocumentId) =>
  `${CLEARANCE_AGENTS_URL}/update-document/${agentDocumentId}`;
export const CLEARANCE_AGENT_GET_ALL_DOCUMENTS_URL =`${CLEARANCE_AGENTS_URL}/documents`;
export const CLEARANCE_AGENT_DELETE_DOCUMENT_URL =`${CLEARANCE_AGENTS_URL}/delete-document`;
export const VENDORS_URL = "/vendors";
export const VENDOR_DOCUMENTS_URL = (vendorId) =>
  `${VENDORS_URL}/${vendorId}/documents`;
export const VENDOR_DOCUMENT_URL = (vendorId, agentDocumentId) =>
  `${VENDOR_DOCUMENTS_URL(vendorId)}/${agentDocumentId}`;
export const BANKS_URL = "/bank";
export const SAVE_BANK = `${BANKS_URL}/add`;
export const DELETE_BANK = `${BANKS_URL}/delete`;
export const SHIPPING_LINES_URL = "/shipping-line";
export const SAVE_SHIPPING_LINE = `${SHIPPING_LINES_URL}/add`;
export const DELETE_SHIPPING_LINE = `${SHIPPING_LINES_URL}/delete`;
export const MATERIALS_URL = "/material";
export const SAVE_MATERIAL = `${MATERIALS_URL}/add`;
export const DELETE_MATERIAL = `${MATERIALS_URL}/delete`;
export const PLANNERS_URL = "/planner";
export const SAVE_PLANNER = `${PLANNERS_URL}/add`;
export const DELETE_PLANNER = `${PLANNERS_URL}/delete`;
export const LINK_PLANNER_WITH_EMAIL = `${PLANNERS_URL}/link-planner`;
/******** Orders **********/
export const COORDINATOR_URL = "/coordinator";
export const ORDERS_URL = "/orders";
export const GROUP_ORDERS_URL = `${ORDERS_URL}/get-grouped`;
export const GET_MANAGER_DASHBOARD_DATA=`${ORDERS_URL}/manager-dashboard`;
export const GET_PAYMENT_DASHBOARD_DATA=`${ORDERS_URL}/payment-dashboard`;
export const EXPORT_ORDERS_XSLS = `${ORDERS_URL}/export-excel`;
export const EXPORT_TRANSACTION_ORDERS_XSLS = `${ORDERS_URL}/export-transaction-excel`;
export const SAVE_ORDER = `${ORDERS_URL}/add`;
export const EXISTS_BY_PO_NUMBER = `${ORDERS_URL}/exists-by-po-number`;
export const ACID_PERMITTED_URL = (orderId) => `${ORDERS_URL}/${orderId}/acid-permitted`;
export const RELEASE_ORDER = `${ORDERS_URL}/release`;
export const GET_ORDERS_URL = `${ORDERS_URL}/get`;
export const GET_TRANSACTION_ORDERS=`${ORDERS_URL}/get/transaction_listing`;
export const GET_GROUPED_TRANSACTION_ORDERS=`${ORDERS_URL}/get/transaction_listing/grouped`;
export const UPDATE_TRANSACTION_ORDER=`${ORDERS_URL}/transaction-page-details`;
export const GET_TRANSACTION_DETAILS=`${ORDERS_URL}/get/transaction-page`;
export const GET_GROUP_TRANSACTION_DETAILS=`${ORDERS_URL}/get/transaction-page/group`;
export const UPDATE_GROUP_TRANSACTION_ORDER=`${ORDERS_URL}/group-transaction-page-details`;
export const UPDATE_BATCH_TRANSACTION_ORDERS=`${ORDERS_URL}/orders/batch-edit`;
export const DELETE_ORDER = `${ORDERS_URL}/delete`;
export const GET_ORDER_COORDINATOR = `${ORDERS_URL}/get/coordinator`;
export const COORDINATOR_UPDATE_ORDER = `${ORDERS_URL}/update${COORDINATOR_URL}`;
export const COORDINATOR_GET_ORDER = `${ORDERS_URL}/get${COORDINATOR_URL}`;
export const ORDER_COMMENTS="/order-comments"
export const PENDING_ORDER_COMMENTS=`${ORDER_COMMENTS}/pending`
export const ORDER_PRIMITIVE_DATA_URL=`${ORDERS_URL}/order-primitive-data`
export const ORDER_INFORMATION_URL=`${ORDERS_URL}/order-information`
export const ORDER_FORM4_INFORMATION_URL = `${ORDERS_URL}/form4-information`
export const ORDER_SPECIFIC_INFORMATION_URL = `${ORDERS_URL}/order-specific-information`
export const ORDER_TRANSPORTATION_DETAILS_URL = `${ORDERS_URL}/order-transportation-details`
export const STAR_ORDERS_URL = `${ORDERS_URL}/star-order`;
export const UNSTAR_ORDERS_URL = `${ORDERS_URL}/unstar-order`;
export const GET_STARRED_ORDERS = `${ORDERS_URL}/get-starred-orders`;
export const GET_STARRED_TRANSACTION_ORDERS = `${ORDERS_URL}/get-starred-transaction-orders`;
export const GENERATE_ORDER_TEMPLATE = `${ORDERS_URL}/generate-template`;
export const UPLOAD_ORDER_EXCEL_FILE = `${ORDERS_URL}/upload-orders`;
export const SET_TO_HAVING_ISSUES = `${ORDERS_URL}/set-having-issues`;
export const SET_AUTOMATIC_STATUS = `${ORDERS_URL}/set-automatically`;
export const IS_ORDER_STARRED = `${ORDERS_URL}/is-order-starred`;
/******** Documents **********/
export const DOCUMENTS_URL = "/document";
export const SAVE_DOCUMENT = `${DOCUMENTS_URL}/add`;
export const LIST_DOCUMENT_TYPES_CREATED = `${DOCUMENTS_URL}/List-types`;

/******** Transportation Documents **********/
export const TRANSPORTATION_DOCUMENTS_URL = "/transportation-document";
/******** Files **********/
export const FILES_URL = "/files"
export const GET_PRESIGNED_LINK = `${FILES_URL}/presignedUrl`;

/******** Form4 PDF **********/
export const FORM4_PDF_URL = "/form4-pdf";

/******** Export Selection **********/
export const EXPORT_SELECTION_URL = "/export-selection";
/******** Notifications **********/
export const NOTIFICATIONS_URL = "/notifications";
export const GET_UNREAD_NOTIFICATIONS = `${NOTIFICATIONS_URL}/unread`;
export const GET_FIRST_TEN_NOTIFICATIONS= `${NOTIFICATIONS_URL}/unread/first-ten`;
/********* Invoices **********/
export const INVOICES_URL = "/invoices";
export const GET_ALL_INVOICES_URL = `${INVOICES_URL}/get-all-invoices`;
export const GET_INVOICE_BY_ID = `${INVOICES_URL}/invoice`;
export const UPDATE_INVOICES_URL = `${INVOICES_URL}/update-invoice`
export const UPDATE_PAYMENTS_URL = `${INVOICES_URL}/update-payment`
export const ADD_PAYMENT_URL = `${INVOICES_URL}/add-payment`
export const DELETE_INVOICE_URL = `${INVOICES_URL}/delete-invoice`
export const DELETE_PAYMENT_URL = `${INVOICES_URL}/delete-payment`
export const EXPORT_PAYMENT_XSLS = `${INVOICES_URL}/export-payments-excel`;
export const GENERATE_TEMPLATE = `${INVOICES_URL}/generate-template`;
export const UPLOAD_PAYMENT_EXCEL_FILE = `${INVOICES_URL}/upload-payments`;
export const GENERATE_ORDER_PAYMENTS_TEMPLATE = `${INVOICES_URL}/generate-order-payments-template`;
export const UPLOAD_ORDER_PAYMENTS_EXCEL_FILE = `${INVOICES_URL}/upload-order-payments`;
/********* Approvals **********/
export const APPROVALS_URL = "/approvals";

/********* CargoX **********/
export const CARGOX_URL = "/cargoX";

/********* Conditions **********/
export const CONDITIONS_URL = "/condition";
export const GENERATE_CONDITIONS_TEMPLATE = `${CONDITIONS_URL}/generate-conditions-template`;
export const UPLOAD_CONDITIONS_EXCEL_FILE = `${CONDITIONS_URL}/upload-conditions`;


/********* Chat **********/
export const AI_CHAT_URL = "/ai-bot";
export const AI_CHAT_ASK_URL = `${AI_CHAT_URL}/ask`;
export const AI_CHAT_CLEAR_CONTEXT_URL = `${AI_CHAT_URL}/clear-context`;

export const LINKAGE_URL="/linkage";
export const GET_LINKAGE_INVOICE_NUMBERS = `${LINKAGE_URL}/invoice-numbers`;

export const MSDS_DOCUMENTS_URL = "/msds-documents";
export const GET_ALL_MSDS_DOCUMENTS = `${MSDS_DOCUMENTS_URL}/get-all`;

export const GET_MSDS_FILE_FOR_ORDER = `${MSDS_DOCUMENTS_URL}/getMSDSFileForOrder`;
